var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// db/currentUserInfo.ts
import { Entity, Field, Query } from "@adornis/baseql/decorators.js";
import { AdornisEntity } from "@adornis/baseql/entities/adornisEntity.js";
import { constructValue } from "@adornis/baseql/entities/construct.js";
import { getRawCollection } from "@adornis/baseql/server/collections.js";
import { context } from "@adornis/baseql/server/context.js";
import "@adornis/baseql/utils/queryGeneration.js";
import { BaseError } from "@adornis/validation/errors/BaseError.js";
import { AdornisUser } from "./a-user.js";
import * as names from "./names.js";
var CurrentUserInfo = class extends AdornisEntity {
  constructor(doc) {
    super(doc);
  }
  static getCurrentUserInfo() {
    return async (gqlFields) => {
      return context.serverContext ? new CurrentUserInfo({ userID: "", impersonatingUserID: null, userClass: null }) : new CurrentUserInfo({
        userID: context.userID,
        impersonatingUserID: context.impersonatingUser,
        userClass: context.userClass
      });
    };
  }
  static getMyself() {
    return async (gqlFields) => {
      if (context.serverContext)
        throw new BaseError(
          "The server does not have a user. If you get this error during context.upgrade or session creation, check your publish filter"
        );
      if (!context.userID)
        return null;
      return constructValue(
        await (await getRawCollection(AdornisUser._collectionName)).findOne({ _id: context.userID })
      );
    };
  }
};
CurrentUserInfo._class = names.currentUserInfoClassName;
__decorateClass([
  Field((type) => String)
], CurrentUserInfo.prototype, "userID", 2);
__decorateClass([
  Field((type) => String)
], CurrentUserInfo.prototype, "userClass", 2);
__decorateClass([
  Field((type) => String)
], CurrentUserInfo.prototype, "impersonatingUserID", 2);
__decorateClass([
  Query((type) => CurrentUserInfo, { requestHandlerMeta: { queryCache: { cachePolicy: "bypass" } } })
], CurrentUserInfo, "getCurrentUserInfo", 1);
__decorateClass([
  Query((type) => AdornisUser, { requestHandlerMeta: { queryCache: { cachePolicy: "bypass" } } })
], CurrentUserInfo, "getMyself", 1);
CurrentUserInfo = __decorateClass([
  Entity()
], CurrentUserInfo);
export {
  CurrentUserInfo
};
